<template>
  <div class="privacy-policy-container">
    <div class="policy-title">北京数聚智连科技股份有限公司隐私政策</div>
    <!-- 日期改为右对齐 -->
    <div class="policy-date">
      发布日期：2026年3月2日<br/>
      生效日期：2026年3月2日
    </div>
    <div class="policy-paragraph">
      我们深知个人信息对您而言的重要性，也感谢您对我们的信任。我们将通过《北京数聚智连科技股份有限公司隐私政策》（下称<span style="font-weight:900;">“本政策”</span>）向您说明您在访问北京数聚智连科技股份有限公司（<span style="font-weight:900;">“我们”</span>）网站或与我们进行信息交互（统称<span style="font-weight:900;">“使用本服务”</span>）时，我们会如何收集、存储、保护、使用及对外提供您的个人信息。同时，我们会通过本政策向您说明，我们如何为您提供访问、更新、管理和保护您的个人信息的服务。
    </div>
    <div class="policy-paragraph" style="font-weight:900;">
      我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款和敏感个人信息，采用粗体字进行标注以提示您注意。本政策与您使用我们的服务关系紧密，我们建议您在使用服务前认真阅读、充分理解本政策条款。若您选择继续使用本服务即视为您已阅读并同意本政策。
    </div>

    <!-- 一、我们如何收集和使用个人信息 -->
    <div class="policy-chapter">一、 我们如何收集和使用个人信息</div>
    <div class="policy-paragraph">
      在您使用本服务的过程中，我们会按照如下方式收集和使用您提供、授权提供或因为使用服务而产生的个人信息：
    </div>
    <div class="policy-paragraph">
      我们将收集您通过“加入我们”“联系我们”等网站功能模块所展示的邮件地址向我们提供的个人邮箱地址、邮件内容以及邮件中可能包含的其他个人信息。我们收集您的前述个人信息仅用于以响应您联系我们所需实现的目的，如与我们进行商务合作沟通、向我们应聘以及向我们检举相关违法违规活动等需求。
    </div>
    <div class="policy-paragraph">
      根据法律法规的相关规定，以下情况下我们有权在不征得您授权同意的情况下处理（包括收集、使用、委托处理、共享、转让和公开披露）您的个人信息：
    </div>
    <div class="policy-list">
      （1）为订立、履行您作为一方当事人的合同所必需；<br/>
      （2）为履行我们的法定义务所必需；<br/>
      （3）为应对突发公共卫生事件或者紧急情况下为保护自然人生命健康和财产安全所必需；<br/>
      （4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理您的个人信息；<br/>
      （5）依照规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；<br/>
      （6）法律、行政法规规定的其他情形。
    </div>
    <div class="policy-paragraph">
      除非您以删除、撤回同意或其他方式拒绝我们处理您的个人信息，在您使用本服务期间，我们将在符合法律法规、与本政策所声明的目的具有直接或合理关联的范围内使用您的个人信息。如我们基于服务所需收集、使用的信息超出前述说明范围的，我们会通过网站页面提示、协议约定等方式另行向您说明信息收集的范围与目的，并按照法律法规的要求征得您的同意。
    </div>
    <div class="policy-paragraph">
      第三方主体可能会通过我们的渠道向您提供服务。当您进入第三方主体运营的服务页面或使用第三方服务、涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策，我们不对第三方主体处理您个人信息的行为负责。
    </div>
    <div class="policy-paragraph">
      您确定，如您向我们提供的个人信息中包括了其他人的个人信息的，您已经向相关人士告知本政策并征求其同意（如适用）。
    </div>

    <!-- 二、我们如何存储和保护个人信息 -->
    <div class="policy-chapter">二、 我们如何存储和保护个人信息</div>
    <div class="policy-paragraph">
      我们会按照法律法规规定，将境内收集的个人信息存储于中国境内。
    </div>
    <div class="policy-paragraph">
      一般而言，我们仅在实现目的所必需的时间内保留您的个人信息，例如与您的合作的期限内。当我们的产品或服务发生停止运营的情形时，我们将以通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。
    </div>
    <div class="policy-paragraph">
      我们会采取合理的措施保护您的个人信息，以防止信息的丢失、泄露、损毁、非授权访问、非授权披露。例如，我们会使用加密技术、匿名化处理、最小化访问权限等手段来保护您的个人信息。我们有严格的信息安全规定和流程，并有专门的信息安全团队在公司内部严格执行上述措施。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并按照相关法律法规的要求告知您和向有关部门报告。
    </div>
    <div class="policy-paragraph">
      请您理解，互联网环境并非百分之百安全，尽管我们有这些安全措施，但请注意在互联网上不存在“完善的安全措施”，我们将尽力确保您的个人信息的安全性。如您发现我们持有的个人信息可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低可能对您带来的不利。
    </div>

    <!-- 三、我们如何委托处理、共享、转让及公开披露个人信息 -->
    <div class="policy-chapter">三、 我们如何委托处理、共享、转让及公开披露个人信息</div>
    <!-- 改为ul无序列表 -->
    <ul class="policy-ul">
      <li>委托处理：为了提升信息处理效率，我们可能会委托第三方代表我们处理您的个人信息。对我们委托处理个人信息的第三方，我们会与其签署委托处理协议，要求其按照协议的约定、本政策以及相关法律法规的要求来处理个人信息，并采取适当的技术与管理措施来保障您的个人信息的安全。</li>
      <li>共享：我们不会与其他公司、组织和个人共享您的个人信息，但以下情况除外：（1）在获得您的单独同意的情况下共享；（2）根据法律规定、有法律赋予权限的政府部门要求的情况下共享；（3）只有提交您的部分信息，才能提供您所要求的服务。</li>
      <li>转让：随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，并按照法律法规及不低于本政策所要求的标准继续保护或要求接收方按本政策约定处理和继续保护您的个人信息。如接收方变更原先的处理目的和方式的，其应当依法重新取得您的授权同意（法律法规另有规定的除外）。</li>
      <li>公开披露：原则上，我们不会对外公开披露收集的个人信息。如确需公开披露，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的个人信息，并征得您的单独同意。</li>
    </ul>

    <!-- 四、您如何访问和管理自己的个人信息 -->
    <div class="policy-chapter">四、 您如何访问和管理自己的个人信息</div>
    <div class="policy-paragraph">
      您在使用本服务期间，如需访问、复制、更正、补充、删除、限制处理您的个人信息，或如您需撤回对您个人信息使用的同意的，或行使其他法定权利的，请您通过本政策“联系我们”部分的联系方式与我们联系，我们将在法定期限内答复您。
    </div>
    <div class="policy-paragraph">
      当您撤回同意（如适用）或删除您的个人信息（如适用）后，我们将根据适用法律法规的要求，删除或匿名化处理您的个人信息。但请注意，您撤回同意的行为不影响我们此前对您个人信息开展处理活动的有效性。
    </div>

    <!-- 五、我们如何保护未成年人的个人信息 -->
    <div class="policy-chapter">五、 我们如何保护未成年人的个人信息</div>
    <div class="policy-paragraph">
      我们仅面向成年人提供产品与服务，不向未满十八周岁的未成年人提供产品与服务。如您发现我们在未经父母或其他监护人同意的情况下收集了未满十八周岁未成年人的个人信息的，请您通过本政策“联系我们”部分的联系方式与我们联系。我们会在核实后按照法律规定以及父母或其他监护人的要求对未成年人的个人信息进行删除或其他处理。
    </div>

    <!-- 六、本政策的适用及更新 -->
    <div class="policy-chapter">六、 本政策的适用及更新</div>
    <div class="policy-paragraph">
      本政策适用于您使用本服务，以及使用我们陆续可能推出的新功能、新服务的情形。发生下列重大变化情形时，我们会对本政策进行更新：（1）我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；（2）收集、存储、使用个人信息的范围、目的、规则发生变化；（3）您访问和管理个人信息的方式，或者询问、投诉的渠道和机制发生变化；（4）数据安全能力、信息安全风险发生变化；（5）其他可能对您的个人信息权益产生重大影响的变化。
    </div>
    <div class="policy-paragraph">
      如本政策发生更新，我们将通过网站公告等方式通知您。如您在本政策更新生效后继续使用本服务，即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。您可以在我们的官网中查看本政策的最新版本。
    </div>

    <!-- 七、联系我们 -->
    <div class="policy-chapter">七、 联系我们</div>
    <div class="policy-paragraph">
      当您对本政策有任何疑问需要我们进行解释的，或者拟就个人信息保护提出投诉、建议的，您可通过如下方式与我们联系：
    </div>
    <!-- 联系邮箱改为ul列表项 -->
    <ul class="policy-ul">
      <li>hegui@intelinkgroup.com</li>
    </ul>
    <div class="policy-paragraph">
      我们将会尽快审核并及时答复您，我们承诺所涉问题将在在验证您的身份后的15个工作日内予以回复处理意见或处理结果。
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {}
  },
  mounted() {
    // 如需页面加载后执行操作，可在此添加
    document.title = '北京数聚智连科技股份有限公司隐私政策'
  }
}
</script>

<style scoped>
/* 整体容器，适配网页正式展示，做基础留白和宽度限制 */
.privacy-policy-container {
  width: 90%;
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
  font-family: "Microsoft YaHei", SimSun, sans-serif;
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  box-sizing: border-box;
  padding-top: 60px;
}
/* 主标题 */
.policy-title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}
/* 发布/生效日期 - 改为右对齐 */
.policy-date {
  text-align: right; /* 核心修改：右对齐 */
  margin-bottom: 30px;
  color: #666;
}
/* 章节标题 */
.policy-chapter {
  font-size: 18px;
  font-weight: bold;
  margin: 30px 0 15px 0;
}
/* 普通段落 */
.policy-paragraph {
  margin: 15px 0;
  text-align: justify;
}
/* 原有列表项 */
.policy-list {
  margin: 15px 0 15px 20px;
  text-align: justify;
}
/* 新增ul无序列表样式，保持正式感 */
.policy-ul {
  margin: 15px 0 15px 20px;
  padding-left: 20px;
  text-align: justify;
}
.policy-ul li {
  margin-bottom: 10px;
  list-style-type: disc; /* 标准圆点项目符号 */
}
/* 最后一个li去掉下外边距 */
.policy-ul li:last-child {
  margin-bottom: 0;
}
/* 联系邮箱 */
.policy-contact {
  margin: 15px 0 15px 20px;
  font-family: Consolas, monospace;
}
/* 响应式适配移动端 */
@media (max-width: 768px) {
  .privacy-policy-container {
    font-size: 14px;
    margin: 20px auto;
  }
  .policy-title {
    font-size: 20px;
  }
  .policy-chapter {
    font-size: 16px;
  }
  .policy-date {
    text-align: right; /* 移动端也保持右对齐 */
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/PrivacyPolicy.vue